<template>
<!--此部分根据设计自动生成，手动修改节点标记daltag="manual"属性，则该节点及子节点不会被自动生成代码覆盖，如发现其他需要调整框架情形请联系:alex.c@daline.com.cn-->
<div id="dal-comp-go">
  <el-table id="aa748c27" :data="tbd_aa748c27" stripe="" border="">
    <el-table-column prop="aa695060" label="项目名称">
    </el-table-column>
    <el-table-column prop="ae3f1f9a" label="客户名称">
    </el-table-column>
    <el-table-column prop="ad35d7b5" label="电话号码">
    </el-table-column>
    <el-table-column prop="b5fc8a91" label="电子邮箱">
    </el-table-column>
    <el-table-column prop="e10c7965" label="项目经理">
    </el-table-column>
    <el-table-column prop="f034d191" label="开始时间">
    </el-table-column>
    <el-table-column prop="a90acc23" label="已耗时">
    </el-table-column>
    <el-table-column prop="aa1a9b5a" label="备注">
    </el-table-column>
  </el-table>
</div>
</template>
<script>
//此文件根据设计自动生成编写框架，请在指定位置编写逻辑代码，如发现框架需要调整的情形请联系:alex.c@daline.com.cn
//在此注释下方添加自定义import
//在此注释下方添加自定义函数
//此注释下方为自动引用部分，请不要修改
export default{
  data(){
    return{
    tbd_aa748c27:[]
      //在此注释下方添加自定义变量
    }
  },
  mounted(){
  },
  computed:{
  },
  watch:{
  },
  methods:{
    //在此注释下方添加自定义函数或事件
  }
}
</script>
<style>
/*此部分根据设计自动生成，自定义样式追加到该部分结尾处*/
#aa748c27{
  width:1323px;
}
#aa748c27{
  display:inline-block;
  vertical-align: middle;
}
/*在此注释下方添加自定义样式*/
</style>
